module.exports = __webpack_public_path__ + "img/guandai_yj_baixiangfeng.49deb8ba.jpg";